export default {"src":"/canvas/_next/static/media/icon-outlook-t5.926f73e3.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};